import script from "./HDFHome.vue?vue&type=script&setup=true&lang=js"
export * from "./HDFHome.vue?vue&type=script&setup=true&lang=js"

import "./HDFHome.vue?vue&type=style&index=0&id=fdf1e4ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdf1e4ca"]])

export default __exports__